export const MY_TEAM = '/my_team/';
